<div class="properties-container">
  <div class="title">
    {{ title }}
  </div>
  <div class="subtitle">
    {{ subtitle }}
  </div>
  <div class="properties-container">
    <div class="property-container" *ngFor="let tooltipProperty of tooltipProperties">
      <div>{{ tooltipProperty.key }}: &nbsp;</div>
      <div>{{ tooltipProperty.value }}</div>
    </div>
    <div class="property-container" *ngIf="!tooltipProperties?.length">
      <span>{{ T_SCOPE + '.no-metadata-found' | translate }} </span>
    </div>
  </div>
</div>
